<template>
  <!-- style="margin-right: -400px;;width: 250px;position: absolute;left: 155px;" -->
  <div>
    <span class="formTitle">
      {{
        value.modalType == "detailsContractCommande"
          ? "Facture"
          : value.modalType == "containerTaxAdd"
          ? "Taxe de vente"
          : manipulateData.modalType == "detailsCartDetailleCommande"
          ? "Bon de commande"
          : manipulateData.modalType == "updateDetailsCartDetailleCommande"
          ? "Commande"
          : manipulateData.modalType == "contratDuplicateData"
          ? "Dupliquer contrat"
          : ""
      }}
    </span>

    <form
      v-if="value.modalType == 'contratDuplicateData'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileFormOne">
        <div class="input-section">
          <label>Produit <span class="required-color">*</span></label>

          <!-- <v-autocompletes
                v-model="value.product"
                :items="productTypeNameList"
                rounded
              ></v-autocomplete> -->
        </div>
        <div class="input-section">
          <label> N de facture <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="value.number"
            placeholder="N de facture"
            required
          />
        </div>
        <div class="input-section">
          <label> Quantité <span class="required-color"> (tonne)</span> </label>
          <input
            type="number"
            v-model="value.tonsQuantity"
            placeholder="Quantité"
            required
          />
        </div>
        <div class="input-section">
          <label> Quantité <span class="required-color">(Sac)</span> </label>
          <input
            type="number"
            v-model="value.quantity"
            placeholder="Quantité"
            required
          />
        </div>
        <div class="input-section">
          <label>Type de devise <span class="required-color">*</span></label>
          <select class="presonalSelect" v-model="value.currency">
            <option disabled value="">-- Sélectionner --</option>
            <option v-for="item in devisesPopulaires" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
          <!-- <v-autocompletes
            v-model="value.currency"
            :items="devisesPopulaires"
            rounded
          ></v-autocomplete> -->
        </div>
        <div class="input-section">
          <label>Montant <span class="required-color">(Devis)</span></label>
          <input
            type="number"
            v-model="value.amountInCurrency"
            placeholder="Montant"
            required
          />
        </div>

        <div class="input-section">
          <label>Montant <span class="required-color">(FCFA)</span></label>
          <input
            type="number"
            v-model="value.amount"
            placeholder="Montant"
            required
          />
        </div>
        <!-- <div class="input-section">
          <label>FCL</label>
          <input type="text" v-model="value.fcl" placeholder="FCL" required />
        </div>
        <div class="input-section">
          <label>Référence</label>
          <input
            type="text"
            v-model="value.referenceReservation"
            placeholder="FCL"
            required
          />
        </div> -->
        <div class="input-section">
          <label>Observation</label>
          <input
            type="text"
            v-model="value.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
    </form>

    <form
      v-if="manipulateData.modalType == 'updateDetailsCartDetailleCommande'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileForm">
        <div class="input-section">
          <label>Produit</label>
          <select class="presonalSelect" v-model="value.product">
            <option disabled value="">-- Sélectionner --</option>
            <option
              v-for="item in productTypeNameList"
              :key="item"
              :value="item"
            >
              {{ item }}
            </option>
          </select>
          <!-- <v-autocompletes
            v-model="manipulateData.product"
            :items="productTypeNameList"
            rounded
            disabled
            class="disabled"
          ></v-autocomplete> -->
        </div>
        <div v-if="manipulateData.product" class="input-section">
          <label>Quantité disponible</label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.totalAvailableQuantity"
            placeholder="Quantité"
            required
          />
        </div>
        <div v-if="manipulateData.product" class="input-section">
          <label>Prix de vente</label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.unitPrice"
            placeholder="Prix de vente"
            required
          />
        </div>
        <div v-if="manipulateData.product" class="input-section">
          <label>Quantité</label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.myQuantity"
            placeholder="Quantité"
            required
          />
        </div>
        <div
          v-if="
            manipulateData.product &&
            manipulateData.myQuantity != manipulateData.quantity
          "
          class="input-section"
        >
          <label>
            <span class="required-color"> Quantité Actualisée</span>
          </label>
          <input
            type="number"
            disabled
            class="disabledError"
            v-model="manipulateData.quantity"
            placeholder="Quantité"
            required
          />
        </div>
        <div v-if="manipulateData.product" class="input-section">
          <label>Montant Total vente</label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.amount"
            placeholder="Montant Total vente"
            required
          />
        </div>
      </div>
      <div v-if="quantityByStore.length === 0">
        <div class="listeDynamicContent">
          <div @click="addIdForUpdateStore(0)" class="addButton">
            <span class="material-icons-sharp">add</span>
            <span> Ajouter magasin</span>
          </div>
        </div>
      </div>
      <div
        v-for="(element, elementIndex) in quantityByStore"
        :key="elementIndex"
        class="fileForm"
      >
        <div class="input-section">
          <label>Magasin de vente</label>
          <select class="presonalSelect" v-model="element.store">
            <option disabled value="">-- Sélectionner --</option>
            <option v-for="item in storeDispo" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
          <!-- <v-autocompletes
            v-model="element.store"
            :items="storeDispo"
            rounded
          ></v-autocomplete> -->
        </div>
        <div class="input-section mt-2">
          <label>
            Quantité a récupérer <span class="required-color">*</span>
          </label>
          <input
            type="number"
            @input="makeCalculeForAll()"
            v-model="element.quantity"
            placeholder="Quantité à récupérer"
            required
          />
        </div>
        <div class="listeDynamicContentSecond">
          <div v-if="elementIndex === quantityByStore.length - 1">
            <div @click="addIdForUpdateStore(index)" class="addButton">
              <span class="material-icons-sharp">add</span>
            </div>
          </div>
          <div
            @click="removeIdForUpdateStore(index, elementIndex)"
            class="closeModalButton"
          >
            <span class="material-icons-sharp">remove</span>
          </div>
        </div>
      </div>
      <!-- <div class="fileForm">
        <div
          v-if="manipulateData.product && manipulateData.quantity"
          class="input-section"
        >
          <label> Bonus de fidelite  <span class="required-color">*</span> </label>
          <input
            type="number"
            @input="calculeTotalForUpdate()"
            v-model="manipulateData.reduction"
            placeholder="Bonus de fidelite "
            required
          />
        </div>
        <div
          v-if="manipulateData.product && manipulateData.quantity"
          class="input-section"
        >
          <label>Observation Bonus de fidelite </label>
          <input
            type="text"
            v-model="manipulateData.observationReduction"
            placeholder="Observation Bonus de fidelite "
            required
          />
        </div>
        <div class="input-section">
          <label> Total vente <span class="required-color">*</span> </label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.amount"
            placeholder="Total vente"
            required
          />
        </div>
      </div> -->
    </form>

    <form
      v-if="manipulateData.modalType == 'detailsCartDetailleCommande'"
      @submit.prevent="handleSubmit"
    >
      <!-- <div class="fileForm">
        <div class="input-section">
          <label> Total vente <span class="required-color">*</span> </label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="manipulateData.amount"
            placeholder="Total vente"
            required
          />
        </div>
      </div> -->

      <div>
        <div
          v-if="
            !manipulateData._id &&
            manipulateData.modalType == 'detailsCartDetailleCommande'
          "
          class="listeDynamicContent"
        >
          <div v-if="commandeDettaillesDynamic.length === 0">
            <div @click="addIdCartDetaille()" class="addButton">
              <span class="material-icons-sharp">add</span>
              <span> Ajouter produit</span>
            </div>
          </div>
        </div>
        <div v-for="(type, index) in commandeDettaillesDynamic" :key="index">
          <div
            v-if="!manipulateData._id && commandeDettaillesDynamic.length > 1"
            class="separation"
          ></div>
          <div
            v-if="
              !manipulateData._id &&
              manipulateData.modalType == 'detailsCartDetailleCommande'
            "
          >
            <div class="fileForm">
              <div class="input-section">
                <label>Produit</label>
                <select
                  class="presonalSelect"
                  @change="findDispo(index)"
                  @input="findDispo(index)"
                  v-model="type.product"
                >
                  <option disabled value="">-- Sélectionner --</option>
                  <option
                    v-for="item in productTypeNameList"
                    :key="item"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
                <!-- <v-autocompletes
                  v-model="type.product"
                  :items="productTypeNameList"
                  rounded
                  @change="findDispo(index)"
                  @input="findDispo(index)"
                ></v-autocomplete> -->
              </div>

              <div v-if="type.product" class="input-section">
                <label>Quantité disponible</label>
                <input
                  type="number"
                  disabled
                  class="disabled"
                  v-model="type.totalAvailableQuantity"
                  placeholder="Quantité"
                  required
                />
              </div>
              <div v-if="type.product" class="input-section">
                <label>Prix de vente</label>
                <input
                  type="number"
                  disabled
                  class="disabled"
                  v-model="type.unitPrice"
                  placeholder="Prix de vente"
                  required
                />
              </div>
              <!-- <div v-if="type.product" class="input-section">
                <label>Quantité</label>
                <input
                  type="number"
                 
                  v-model="type.quantity"
                  placeholder="Quantité"
                  required
                />
              </div> -->
              <div v-if="type.product">
                <div v-if="type.quantityByStore.length === 0">
                  <div @click="addIdStore(0)" class="addButton">
                    <span class="material-icons-sharp">add</span>
                    <span> Ajouter magasin</span>
                  </div>
                </div>
                <div
                  v-for="(element, elementIndex) in type.quantityByStore"
                  :key="elementIndex"
                >
                  <div class="input-section">
                    <label>Magasin de vente</label>
                    <select class="presonalSelect" v-model="element.store">
                      <option disabled value="">-- Sélectionner --</option>
                      <option
                        v-for="item in type.storeDispo"
                        :key="item"
                        :value="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                    <!-- <v-autocompletes
                      v-model="element.store"
                      :items="type.storeDispo"
                      rounded
                    ></v-autocomplete> -->
                  </div>
                  <div class="input-section mt-2">
                    <label>
                      Quantité a récupérer
                      <span class="required-color">*</span>
                    </label>
                    <input
                      type="number"
                      @input="calculeTotalDétaille(index)"
                      v-model="element.quantity"
                      placeholder="Quantité à récupérer"
                      required
                    />
                  </div>
                  <div class="listeDynamicContentSecond">
                    <div
                      v-if="elementIndex === type.quantityByStore.length - 1"
                    >
                      <div @click="addIdStore(index)" class="addButton">
                        <span class="material-icons-sharp">add</span>
                      </div>
                    </div>
                    <div
                      @click="removeIdStore(index, elementIndex)"
                      class="closeModalButton"
                    >
                      <span class="material-icons-sharp">remove</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div v-if="type.product" class="input-section">
                <label>Total Quantité de vente</label>
                <input
                  type="number"
                  disabled
                  class="disabled"
                  @input="calculeTotal()"
                  v-model="type.quantity"
                  placeholder="Quantité"
                  required
                />
              </div>
              <div v-if="type.product && type.quantity" class="input-section">
                <label> Bonus de fidélité <span class="required-color">*</span> </label>
                <input
                  type="number"
                  @input="calculeTotal()"
                  v-model="type.reduction"
                  placeholder="Bonus de fidélité"
                  required
                />
              </div>
              <div v-if="type.product && type.quantity" class="input-section">
                <label>Observation Bonus de fidélité</label>
                <input
                  type="text"
                  v-model="type.observationReduction"
                  placeholder="Observation Bonus de fidélité"
                  required
                />
              </div> -->
            </div>
            <div class="listeDynamicContent">
              <div v-if="index === commandeDettaillesDynamic.length - 1">
                <div @click="addIdCartDetaille()" class="addButton">
                  <span class="material-icons-sharp">add</span>
                  <span> Ajouter produit</span>
                </div>
              </div>
              <div
                @click="removeIdCartDetaille(index)"
                class="closeModalButton"
              >
                <span class="material-icons-sharp">remove</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form
      v-if="value.modalType == 'containerTaxAdd'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileFormOne">
        <div class="input-section">
          <label>Type <span class="required-color">*</span></label>
          <select class="presonalSelect" v-model="value.typeOfTaxe">
            <option disabled value="">-- Sélectionner --</option>
            <option v-for="item in typeOfTaxesList" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
          <!-- <v-autocompletes
            v-model="value.typeOfTaxe"
            :items="typeOfTaxesList"
            rounded
          ></v-autocomplete> -->
        </div>
        <div v-if="value.typeOfTaxe" class="input-section">
          <label
            >Désignation {{ value.typeOfTaxe }}
            <span class="required-color">*</span>
          </label>
          <select class="presonalSelect" v-model="value.nameSelect">
            <option disabled value="">-- Sélectionner --</option>
            <option
              v-for="item in value.typeOfTaxe == 'Transit'
                ? typeOftransiteList
                : taxeFixeListe"
              :key="item"
              :value="item"
            >
              {{ item }}
            </option>
          </select>
          <!-- <v-autocompletes
            v-model="value.nameSelect"
            :items="
              value.typeOfTaxe == 'Transit' ? typeOftransiteList : taxeFixeListe
            "
            rounded
          ></v-autocomplete> -->
        </div>
        <div
          v-if="value.nameSelect == 'Autres ...' && value.typeOfTaxe == 'Taxe'"
          class="input-section"
        >
          <label
            >Désignation de autre surtaxe
            <span class="required-color">*</span>
          </label>
          <input
            type="text"
            v-model="value.nameText"
            placeholder="Désignation de surtaxe"
            required
          />
        </div>
        <div
          v-if="value.nameSelect && value.typeOfTaxe == 'Taxe'"
          class="input-section"
        >
          <label> Nombre de jour <span class="required-color">*</span> </label>
          <input
            type="number"
            v-model="value.numberOfDays"
            placeholder="Nombre de jour"
            required
          />
        </div>
        <div v-if="value.nameSelect" class="input-section">
          <label> Montant <span class="required-color">*</span> </label>
          <input
            type="number"
            v-model="value.amount"
            placeholder="Montant"
            required
          />
        </div>
      </div>
    </form>

    <form
      v-if="value.modalType == 'detailsContractCommande'"
      @submit.prevent="handleSubmit"
    >
      <div class="fileFormOne">
        <div class="input-section">
          <label>Produit <span class="required-color">*</span></label>
          <select
            class="presonalSelect"
            v-model="value.product"
            @change="checkProductInfo(value.product)"
          >
            <option disabled value="">-- Sélectionner --</option>
            <option
              v-for="item in productTypeNameList"
              :key="item"
              :value="item"
            >
              {{ item }}
            </option>
          </select>
          <!-- <v-autocompletes
            v-model="value.product"
            :items="productTypeNameList"
            rounded
            @change="checkProductInfo(value.product)"
          ></v-autocomplete> -->
        </div>
        <div class="input-section">
          <label> N de facture <span class="required-color">*</span> </label>
          <input
            type="text"
            v-model="value.number"
            placeholder="N de facture"
            required
          />
        </div>
        <div v-if="value.product" class="input-section">
          <label> Quantité <span class="required-color"> (tonne)</span> </label>
          <input
            type="number"
            v-model="value.tonsQuantity"
            placeholder="Quantité tonne"
            @input="getTonneAmount"
            required
          />
        </div>
        <div v-if="value.product" class="input-section">
          <label>
            Quantité
            <span class="required-color">({{ ProductContentType }})</span>
          </label>
          <input
            type="number"
            v-model="value.quantity"
            placeholder="Quantité Sac"
            @input="getTonneAmount"
            required
          />
        </div>
        <div class="input-section">
          <label>Type de devise <span class="required-color">*</span></label>
          <select
            class="presonalSelect"
            v-model="value.currency"
            @input="getTonneAmount"
          >
            <option disabled value="">-- Sélectionner --</option>
            <option v-for="item in devisesPopulaires" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
          <!-- <v-autocompletes
            v-model="value.currency"
            :items="devisesPopulaires"
            @input="getTonneAmount"
            rounded
          ></v-autocomplete> -->
        </div>
        <div v-if="value.currency" class="input-section">
          <label
            >Montant
            <span class="required-color">({{ value.currency }})</span></label
          >
          <input
            type="number"
            v-model="value.amountInCurrency"
            @input="getTonneAmount"
            placeholder="Montant devise"
            required
          />
        </div>

        <div v-if="value.currency" class="input-section">
          <label>Montant <span class="required-color">(FCFA)</span></label>
          <input
            type="number"
            v-model="value.amount"
            placeholder="Montant FCFA"
            @input="getTonneAmount"
            required
          />
        </div>
        <div v-if="value.currency" class="input-section">
          <label
            >Prix a la tonne
            <span class="required-color">({{ value.currency }})</span></label
          >
          <input
            type="number"
            disabled
            class="disabled"
            v-model="value.tonsAmount"
            placeholder="Prix a la tonne"
            required
          />
        </div>
        <!-- <div class="input-section">
          <label>FCL</label>
          <input type="text" v-model="value.fcl" placeholder="FCL" required />
        </div>
        <div class="input-section">
          <label>Référence</label>
          <input
            type="text"
            v-model="value.referenceReservation"
            placeholder="FCL"
            required
          />
        </div> -->
        <div class="input-section">
          <label>Observation</label>
          <input
            type="text"
            v-model="value.observation"
            placeholder="Observation"
            required
          />
        </div>
      </div>
    </form>

    <div class="contentButton">
      <div @click="submitForm" class="buttonDone">
        <span> Soumettre</span>
      </div>
    </div>
  </div>
</template>
    
    <script>
import {
  addTaxDetails,
  updateTaxDetails,
  addContratDetails,
  updateContratDetails,
  addCartDetails,
  updateCartDetails,
} from "../api/user";
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "../utils/data";
export default {
  props: {
    value: {
      type: Object, // Type de la valeur que vous attendez
      required: true, // Indique que cette prop est requise
    },
  },
  data() {
    return {
      filteredItems: [],
      manipulateData: null,
      showList: false,
      showListRole: false,
      unitOfMeasurements: [],
      showListUnit: false,
      showListConteneur: false,
      supplierTypeNameList: [],
      productTypeNameList: [],
      showListProduct: false,
      filteredItemsProduct: [],
      conteneurTypeNameList: [],
      typeOfTaxesList: ["Transit", "Taxe"],
      typeOftransiteList: [
        "Valeurs taxées",
        "Totaux déclarations",
        "Montants BFU",
        "Valeurs Douane attestées CFA",
        "Valeurs Douane déclarées CFA",
      ],
      taxeFixeListe: [
        "Gardiennages",
        "Surestaries",
        "Stationnements portuaires",
        "Dépôts Douane",
        "Autres ...",
      ],
      devisesPopulaires: [
        "Euro (€)",
        "Dollar américain ($)",
        "Livre sterling (£)",
        "Yen japonais (¥)",
        "Franc suisse (CHF)",
        "Dollar canadien (CA$)",
        "Dollar australien (AU$)",
        "Roupie indienne (₹)",
        "Yuan chinois (¥)",
      ],
      ProductContentType: "-",
      commandeDettaillesDynamic: [
        {
          product: "",
          quantity: 0,
          quantityByStore: [
            {
              store: "",
              quantity: 0,
            },
          ],
          observation: "",
          // store: "",
          unitPrice: 0,
          reduction: 0,
          observationReduction: "",
          storeDispo: [],
          storeSelectId: "",
          totalAvailableQuantity: 0,
        },
      ],
      storeDispo: [],
      quantityByStore: [
        {
          store: "",
          quantity: 0,
        },
      ],
      formTypes: [
        {
          containType: "",
          totalContainer: 1,
        },
      ],
    };
  },
  watch: {
    supplierData() {
      this.supplierTypeNameList = defaultMethods.getNameList(this.supplierData);
    },
    productData() {
      // alert('ok')
      this.productTypeNameList = defaultMethods.getNameList(this.productData);
    },
    conteneurData() {
      this.conteneurTypeNameList = defaultMethods.getNameList(
        this.conteneurData
      );
    },
    // productData() {
    //   this.productTypeNameList = defaultMethods.getNameList(
    //     this.productData
    //   );
    // },
    value() {
      // alert("ok");

      this.manipulateData = {};
      this.commandeDettaillesDynamic = [
        {
          product: "",
          quantity: 0,
          quantityByStore: [
            {
              store: "",
              quantity: 0,
            },
          ],
          observation: "",
          // store: "",
          unitPrice: 0,
          reduction: 0,
          observationReduction: "",
          storeDispo: [],
          storeSelectId: "",
          totalAvailableQuantity: 0,
        },
      ];
      if (this.value.modalType == "detailsContractCommande") {
        this.checkProductInfo(this.value.product);
      }
      console.log("manipulateData", this.manipulateData);
      console.log("value", this.value);

      this.manipulateData = this.value;
      this.findDispoForUpdate();
      this.quantityByStore = [
        {
          store: this.value.store,
          quantity: this.value.quantity,
        },
      ];
      this.getTonneAmount();
      console.log("quantityByStore", this.quantityByStore);
    },
  },

  computed: {
    ...mapGetters(["productData", "conteneurData", "storeData"]),
  },
  async mounted() {
    this.formTypes = [
      {
        containType: "",
        totalContainer: 1,
      },
    ];
    // alert(JSON.stringify(this.value))
  },
  methods: {
    ...mapActions([
      "getContratDetails",
      "getTaxOfContainer",
      "getTransitContainer",
      "getTaxOtherOfContainer",
      "getFindProductStockDispo",
      "getCardDetails",
      "getCard",
      "getBl",
    ]),
    // handleSubmit() {
    //   // Émet l'événement 'formSubmitted' et envoie les données du formulaire

    // },
    makeCalculeForAll() {
      this.manipulateData.amount = 0;
      const sommeQuantity = this.quantityByStore.reduce((acc, current) => {
        return Number(acc) + Number(current.quantity);
      }, 0);
      if (sommeQuantity > this.manipulateData.totalAvailableQuantity) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad(
            "La quantité de produit acheté par l'utilisateur est supérieure à la quantité disponible en stock veuillez contacter l'administrateur pour plus d'indications"
          )
        );
      }
      this.manipulateData.quantity = sommeQuantity;
      this.manipulateData.amount =
        sommeQuantity * Number(this.manipulateData.unitPrice);
    },
    async findDispoForUpdate() {
      // alert(this.manipulateData.product)
      if (
        this.manipulateData.modalType == "updateDetailsCartDetailleCommande"
      ) {
        // const product = this.manipulateData.product;

        // Sinon, continuer avec la logique d'origine
        await this.getFindProductStockDispo({
          product: defaultMethods.getItemId(
            this.productData,
            this.manipulateData.product
          ),
          // quantity: this.commandeDettaillesDynamic[index].quantity,
        })
          .then((res) => {
            // alert(JSON.stringify(res));
            // this.commandeDettaillesDynamic[index].totalAvailableQuantity =
            //   res.totalAvailableQuantity;
            // this.commandeDettaillesDynamic[index].unitPrice =
            //   res.data[0].product.unitPrice;
            this.storeDispo = defaultMethods.getNameList(res.data);
            // this.calculeTotal();
            // console.log("dynamicContente", this.commandeDettaillesDynamic);
          })
          .catch((error) => {
            // Handle any errors from getFindProductStockDispo
            console.error(error);
          });

        console.log("disponibilitee", this.storeDispo);
      }
    },
    addIdCartDetaille() {
      this.commandeDettaillesDynamic.push({
        product: "",
        quantity: 0,
        quantityByStore: [
          {
            store: "",
            quantity: 0,
          },
        ],
        observation: "",
        // store: "",
        unitPrice: 0,
        reduction: 0,
        observationReduction: "",
        storeDispo: [],
        storeSelectId: "",
        totalAvailableQuantity: 0,
      });
    },
    calculeTotalDétailleUpdate() {
      // Remplacer les valeurs vides par 0

      this.manipulateData.quantity = 0;

      for (var i = 0; i < this.quantityByStore.length; i++) {
        // Convertir les valeurs vides en 0
        const quantity = this.quantityByStore[i].quantity || 0;

        // Ajouter le montant calculé au montant total
        this.manipulateData.quantity += Number(quantity);
      }
      this.calculeTotalForUpdate();
      // alert(this.manipulateData.amount)
    },
    calculeTotalForUpdate() {
      // Remplacer les valeurs vides par 0

      this.manipulateData.amount = 0;

      for (var i = 0; i < this.commandeDettaillesDynamic.length; i++) {
        // Convertir les valeurs vides en 0
        const unitPrice = this.manipulateData.unitPrice || 0;
        const quantity = this.manipulateData.quantity || 0;
        const reduction = this.manipulateData.reduction || 0;

        // Calculer le montant pour chaque élément de commande
        const amount = Number(unitPrice) * Number(quantity) - Number(reduction);

        // Ajouter le montant calculé au montant total
        this.manipulateData.amount += amount;
      }
      // alert(this.manipulateData.amount)
    },
    removeIdCartDetaille(index) {
      this.commandeDettaillesDynamic.splice(index, 1); // Supprimer un seul élément à l'index donné
    },
    addId() {
      this.formTypes.push({
        containType: "",
        totalContainer: 1,
      });
    },
    addIdForUpdateStore() {
      this.quantityByStore.push({
        store: "",
        quantity: 0,
      });
      this.makeCalculeForAll();
    },
    removeIdForUpdateStore(elementIndex) {
      this.quantityByStore.splice(elementIndex, 1); // Supprimer un seul élément à l'index donné
      this.makeCalculeForAll();
    },
    removeId(index) {
      this.formTypes.splice(index, 1); // Supprimer un seul élément à l'index donné
    },
    addNewMinusContrat() {
      this.$emit("show", true);
      const value = {
        modalType: "detailsContract",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "detailsContract",
        size: 600,
        value: value,
      });
      this.$emit("show", false);
    },
    filterOptions() {
      this.filteredItems = this.items.filter((item) =>
        item.toLowerCase().includes(this.value.type.toLowerCase())
      );
    },
    filterOptionsUnit() {
      this.unitOfMeasurements = this.unitItems.filter((item) =>
        item.toLowerCase().includes(this.value.unitOfMeasurement.toLowerCase())
      );
    },

    selectItem(item) {
      this.value.type = item;
      this.filteredItems = [];
      this.showList = false;
    },
    selectItemUnit(item) {
      this.value.unitOfMeasurement = item;
      this.unitOfMeasurements = [];
      this.showListUnit = false;
    },
    selectItemRoles(item) {
      this.value.role = item;
      this.filterOptionsUser = [];
      this.showListRole = false;
    },
    getTonneAmount() {
      this.value.tonsAmount = Math.round(
        this.value.amountInCurrency / this.value.tonsQuantity
      );
    },
    selectItemConteneur(item) {
      this.value.name = item.type;
      this.value.description = item.description; // Ajout de la description
      this.conteneurListe = [];
      this.showListConteneur = false;
    },
    selectItemSupplier(item) {
      this.value.supplier = item;
      this.supplierListeData = [];
      this.showListSupplier = false;
    },
    filterSupplierFunction() {
      this.supplierListeData = this.supplierTypeNameList.filter((item) =>
        item.toLowerCase().includes(this.value.supplier.toLowerCase())
      );
    },
    filterOptionsFunction() {
      this.filterOptionsUser = this.roleListe.filter((item) =>
        item.toLowerCase().includes(this.value.role.toLowerCase())
      );
    },
    filterOptionsConteneurFunction() {
      this.conteneurListe = this.conteneurItems.filter((item) =>
        item.type.toLowerCase().includes(this.value.name.toLowerCase())
      );
    },
    filterOptionsProduct() {
      this.filteredItemsProduct = this.productTypeNameList.filter((item) =>
        item.toLowerCase().includes(this.value.product.toLowerCase())
      );
    },

    async findDispo(index) {
      const product = this.commandeDettaillesDynamic[index].product;

      // Vérifier si le produit existe déjà à un autre index
      const productExists = this.commandeDettaillesDynamic.some(
        (item, i) => i !== index && item.product === product
      );

      if (productExists) {
        // Si le produit existe déjà à un autre index, afficher une erreur
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("Le produit existe déjà dans votre liste")
        );
        // Effacer l'élément à l'index donné
        this.commandeDettaillesDynamic.splice(index, 1);
      } else {
        // Sinon, continuer avec la logique d'origine
        await this.getFindProductStockDispo({
          product: defaultMethods.getItemId(
            this.productData,
            this.commandeDettaillesDynamic[index].product
          ),
          // quantity: this.commandeDettaillesDynamic[index].quantity,
        })
          .then((res) => {
            this.commandeDettaillesDynamic[index].totalAvailableQuantity =
              res.totalAvailableQuantity;
            this.commandeDettaillesDynamic[index].unitPrice =
              res.data[0].product.unitPrice;
            this.commandeDettaillesDynamic[index].storeDispo =
              defaultMethods.getNameList(res.data);
            this.calculeTotal();
            console.log("dynamicContente", this.commandeDettaillesDynamic);
          })
          .catch((error) => {
            // Handle any errors from getFindProductStockDispo
            console.error(error);
          });

        console.log(this.commandeDettaillesDynamic);
      }
    },
    checkProductInfo(item) {
      const productInfo = defaultMethods.getItemInfo(this.productData, item);
      // alert(JSON.stringify(productInfo))
      this.ProductContentType = productInfo.type;
    },
    calculeTotal() {
      // Remplacer les valeurs vides par 0

      this.manipulateData.amount = 0;

      for (var i = 0; i < this.commandeDettaillesDynamic.length; i++) {
        // Convertir les valeurs vides en 0
        const unitPrice = this.commandeDettaillesDynamic[i].unitPrice || 0;
        const quantity = this.commandeDettaillesDynamic[i].quantity || 0;
        const reduction = this.commandeDettaillesDynamic[i].reduction || 0;

        // Calculer le montant pour chaque élément de commande
        const amount = Number(unitPrice) * Number(quantity) - Number(reduction);

        // Ajouter le montant calculé au montant total
        this.manipulateData.amount += amount;
      }
      // alert(this.manipulateData.amount)
    },
    addIdStore(index) {
      this.commandeDettaillesDynamic[index].quantityByStore.push({
        store: "",
        quantity: 0,
      });
    },
    removeIdStore(index, elementIndex) {
      this.commandeDettaillesDynamic[index].quantityByStore.splice(
        elementIndex,
        1
      ); // Supprimer un seul élément à l'index donné
    },
    calculeTotalDétaille(index) {
      // Remplacer les valeurs vides par 0

      this.commandeDettaillesDynamic[index].quantity = 0;

      for (
        var i = 0;
        i < this.commandeDettaillesDynamic[index].quantityByStore.length;
        i++
      ) {
        // Convertir les valeurs vides en 0
        const quantity =
          this.commandeDettaillesDynamic[index].quantityByStore[i].quantity ||
          0;

        // Ajouter le montant calculé au montant total
        this.commandeDettaillesDynamic[index].quantity += Number(quantity);
      }
      this.calculeTotal();
      // alert(this.manipulateData.amount)
    },
    selectItemProduct(item) {
      this.value.product = item;
      this.filteredItemsProduct = [];
      this.showListProduct = false;
    },
    calculateReduction(quantityBuy, reduction, quantity) {
      const reductionAmount = (quantityBuy * reduction) / quantity;
      return reductionAmount;
    },
    async submitForm() {
      this.$emit("show", true);
      try {
        if (this.value.modalType == "detailsContractCommande") {
          const schema = {
            product: defaultMethods.getItemId(
              this.productData,
              this.value.product
            ),
            number: this.value.number,
            quantity: this.value.quantity,
            tonsQuantity: this.value.tonsQuantity,
            contract: this.value.contratId,
            // containTypes: defaultMethods.getItemFormTypeId(
            //   this.conteneurData,
            //   this.formTypes
            // ),
            observation: this.value.observation,
            amount: this.value.amount,
            tonsAmount: this.value.tonsAmount,
            amountInCurrency: this.value.amountInCurrency,
            currency: this.value.currency,
            // fcl: this.value.fcl,
            // referenceReservation: this.value.referenceReservation,
          };
          if (this.value._id) {
            await updateContratDetails({
              schema,
              id: this.value._id,
            });
            await this.getContratDetails({ contract: this.value.contratId });
            this.$emit("closeAllModal");
          } else {
            await addContratDetails({
              schema,
            });
            await this.getContratDetails({ contract: this.value.contratId });
            this.$emit("closeAllModal");
          }
        } else if (this.value.modalType == "contratDuplicateData") {
          const schema = {
            product: defaultMethods.getItemId(
              this.productData,
              this.value.product
            ),
            number: this.value.number,
            quantity: this.value.quantity,
            tonsQuantity: this.value.tonsQuantity,
            contract: this.value.contratId,
            // containTypes: defaultMethods.getItemFormTypeId(
            //   this.conteneurData,
            //   this.formTypes
            // ),
            observation: this.value.observation,
            amount: this.value.amount,
            amountInCurrency: this.value.amountInCurrency,
            currency: this.value.currency,
            // fcl: this.value.fcl,
            // referenceReservation: this.value.referenceReservation,
          };
          if (this.value._id) {
            await updateContratDetails({
              schema,
              id: this.value._id,
            });
            await this.getContratDetails({ contract: this.value.contratId });
            this.$emit("closeAllModal");
          } else {
            await addContratDetails({
              schema,
            });
            await this.getContratDetails({ contract: this.value.contratId });
            this.$emit("closeAllModal");
          }
        } else if (this.value.modalType == "containerTaxAdd") {
          const schema = {
            bl: this.value.contratId,
            name:
              this.value.nameSelect == "Autres ..."
                ? this.value.nameText
                : this.value.nameSelect,
            amount: this.value.amount,
            nature:
              this.value.nameSelect == "Autres ..."
                ? "Autres Taxe"
                : this.value.typeOfTaxe,
            numberOfDays:
              this.value.typeOfTaxe == "Transit" ? 0 : this.value.numberOfDays,
          };
          if (this.value._id) {
            await updateTaxDetails({
              schema,
              id: this.value._id,
            });
            await this.getTransitContainer({ bl: this.value.contratId });
            await this.getTaxOfContainer({ bl: this.value.contratId });
            await this.getTaxOtherOfContainer({ bl: this.value.contratId });
            this.$emit("closeAllModal");
          } else {
            await addTaxDetails({
              schema,
            });
            await this.getTransitContainer({ bl: this.value.contratId });
            await this.getTaxOfContainer({ bl: this.value.contratId });
            await this.getTaxOtherOfContainer({ bl: this.value.contratId });
            await this.getBl({});
            this.$emit("closeAllModal");
          }
        } else if (
          this.manipulateData.modalType == "detailsCartDetailleCommande"
        ) {
          for (const item of this.commandeDettaillesDynamic) {
            for (const element of item.quantityByStore) {
              const trueAmount =
                Number(item.unitPrice) * Number(element.quantity);
              const schema = {
                cart: this.manipulateData.cartId,
                product: defaultMethods.getItemId(
                  this.productData,
                  item.product
                ),
                amount: trueAmount,
                store: defaultMethods.getItemId(
                  this.storeData,
                  element.store.substring(0, element.store.indexOf("(")).trim()
                ),
                quantity: element.quantity > 0 ? element.quantity : 1,
              };
              await addCartDetails({ schema });
            }
          }
          await this.getCard({ status: "Attente", alreadyExpired: false });
          await this.getCardDetails({ cart: this.manipulateData.cartId });

          this.$emit("closeAllModal");
        } else if (
          this.manipulateData.modalType == "updateDetailsCartDetailleCommande"
        ) {
          if (this.manipulateData._id) {
            for (const element of this.quantityByStore) {
              const schema = {
                product: defaultMethods.getItemId(
                  this.productData,
                  this.manipulateData.product
                ),
                // reduction: 0,
                amount: this.manipulateData.unitPrice * element.quantity,
                cart: this.manipulateData.cartUseId,
                store: defaultMethods.getItemId(
                  this.storeData,
                  element.store.substring(0, element.store.indexOf("(")).trim()
                ),
                quantity: element.quantity,
                observationReduction: this.manipulateData.observationReduction,
              };
              if (this.manipulateData._id) {
                await updateCartDetails({
                  schema,
                  id: this.manipulateData._id,
                });
                this.manipulateData._id = "";
              } else {
                await addCartDetails({ schema });
              }
            }
          }
          await this.getCardDetails({ cart: this.manipulateData.cartUseId });

          this.$emit("closeAllModal");
        }
      } catch (error) {
        console.error("Bloc catch : une exception a été attrapée !");
        console.error("My error", error.message);
      } finally {
        console.log("Bloc finally : ce code sera toujours exécuté.");
        this.$emit("show", false);
      }
    },
  },
};
</script>
    
    <style scoped>
/* .container {
  display: grid;
  width: 96%;
  margin: 0 auto;
  gap: 1.8rem;
  grid-template-columns: 12rem auto 23rem;
} */
/* Styles spécifiques au composant */
</style>
    